import "./RemoveBoard.scss";
import { useTranslation, Trans } from "react-i18next";

function RemoveBoard({ boardName, removeBoard, cancelRemoveBoard }) {
  const { t } = useTranslation();
  return (
    <div className="remove-board-content">
      <div className="modal-title">
        <div>{t("tasks.modals.removeBoard.title")}</div>
      </div>
      <div className="modal-body">
        <p>{t("tasks.modals.removeBoard.message", { name: boardName })}</p>
        <p className="remove-warning">
          <Trans
            i18nKey="tasks.modals.removeBoard.warning"
            components={{ bold: <strong /> }}
          />
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveBoard}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeBoard}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveBoard;
